import React from 'react';

const ID = 'navbar';
export interface NavbarProps {
    children: React.ReactNode;
}

export const Navbar = (props: NavbarProps) => {
    return (
        <div
            id={ID}
            className='border-border-default flex items-center justify-around gap-3 self-stretch border-t bg-background-surface py-5 px-3'>
            {props.children}
        </div>
    );
};
